//#region Imports
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedModule } from './shared.module';
//#endregion

//#region General Information
import { AddressComponent } from 'src/app/views/general-information/address/address.component';
import { DependencyComponent } from 'src/app/views/general-information/dependency/dependency.component';
import { HouseApartmentComponent } from 'src/app/views/general-information/house-apartment/house-apartment.component';
import { InsuredValueComponent } from 'src/app/views/general-information/insured-value/insured-value.component';
import { NumberPiecesComponent } from 'src/app/views/general-information/number-pieces/number-pieces.component';
import { NumberRoommateComponent } from 'src/app/views/general-information/number-roommate/number-roommate.component';
import { OwnerTenantComponent } from 'src/app/views/general-information/owner-tenant/owner-tenant.component';
import { ParticularityComponent } from 'src/app/views/general-information/particularity/particularity.component';
import { PreferentialRateComponent } from 'src/app/views/general-information/preferential-rate/preferential-rate.component';
import { PreviousClaimComponent } from 'src/app/views/general-information/previous-claim/previous-claim.component';
import { PrimarySecondaryComponent } from 'src/app/views/general-information/primary-secondary/primary-secondary.component';
import { RoomAreaComponent } from 'src/app/views/general-information/room-area/room-area.component';
import { SolidarityAddressComponent } from 'src/app/views/general-information/solidarity-address/solidarity-address.component';
import { EtudiantAgeComponent } from 'src/app/views/general-information/etudiant-age/etudiant-age.component';
//#endregion

export const modules = [
  EtudiantAgeComponent,
  SolidarityAddressComponent,
  AddressComponent,
  HouseApartmentComponent,
  OwnerTenantComponent,
  PrimarySecondaryComponent,
  PreferentialRateComponent,
  NumberPiecesComponent,
  RoomAreaComponent,
  PreviousClaimComponent,
  DependencyComponent,
  ParticularityComponent,
  InsuredValueComponent,
  NumberRoommateComponent
];

@NgModule({
  declarations: [...modules],
  imports: [RouterModule, CommonModule, SharedModule],
  exports: [...modules]
})
export class GeneralInformationModule {}
